import { render, staticRenderFns } from "./userView.vue?vue&type=template&id=2976cba0&scoped=true"
import script from "./userView.vue?vue&type=script&lang=js"
export * from "./userView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2976cba0",
  null
  
)

export default component.exports